import { Body, Icon } from "~/ui-library";
import {
  CheckCircleOutlineIcon,
  CircleOutlineIcon,
  InformationCircleOutlineIcon,
} from "~/ui-library/icons";
import { cx } from "cva";
import React from "react";

type BreadcrumbsStepStatus = "pending" | "active" | "info" | "complete";

export type BreadcrumbStepProps = {
  title: string;
  status: BreadcrumbsStepStatus;
};

export type SubCheckoutBreadcrumbsProps = {
  breadcrumbs: BreadcrumbStepProps[];
  className?: string;
};

function getStepIcon(status: BreadcrumbsStepStatus) {
  switch (status) {
    case "pending":
      return (
        <Icon
          className="mr-xxs fill-transparent stroke-gray-700 md:mr-xs"
          SvgIcon={CircleOutlineIcon}
        />
      );
    case "active":
      return (
        <Icon
          className="mr-xxs fill-transparent stroke-black md:mr-xs"
          SvgIcon={CircleOutlineIcon}
        />
      );
    case "info":
      return (
        <Icon
          className="mr-xxs fill-transparent stroke-primary md:mr-xs"
          SvgIcon={InformationCircleOutlineIcon}
        />
      );
    case "complete":
    default:
      return (
        <Icon
          className="mr-xxs fill-transparent stroke-primary md:mr-xs"
          SvgIcon={CheckCircleOutlineIcon}
        />
      );
  }
}

const BreadcrumbsStep: React.FC<BreadcrumbStepProps> = ({ title, status }) => (
  <div className="mx-xxs w-fit md:mx-xs">
    {getStepIcon(status)}
    <Body
      size="extraSmall"
      bold={true}
      className={cx(
        "inline",
        status === "pending" ? "text-gray-700" : "text-black"
      )}
    >
      {title}
    </Body>
  </div>
);

export const SubCheckoutBreadcrumbs: React.FC<SubCheckoutBreadcrumbsProps> = ({
  breadcrumbs: stepPropCollection,
  className,
}) => (
  <div className={cx(className, "flex w-full items-center justify-center")}>
    {stepPropCollection.map((stepProps, index) => (
      <React.Fragment key={index}>
        <BreadcrumbsStep {...stepProps} />
        {stepPropCollection.length !== index + 1 ? (
          <hr className="w-s text-gray-300 md:w-xl" />
        ) : null}
      </React.Fragment>
    ))}
  </div>
);
